import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Select,
  Container,
  MenuItem,
  FormControlLabel,
  Paper,
  Switch,
  TextField,
  Typography,
  Divider,
  CircularProgress,
  Tooltip,
  IconButton,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import useTerminalPos from '../../hooks/useTerminal/useTerminalPos';
import kırmızı from '../../assets/kırmızı.png';
import kuikPos from '../../services/api/kuikPos';
import UpdateTerminalModal from './UpdateTerminalModal';
import Icon from '../../components/Icon';

const {
  createTerminalPos,
  fetchTerminals,
  createPaymentGateway,
  getPaymentSettings,
} = useTerminalPos;

const KuikPosPage = () => {
  const [name, setName] = useState('');
  const [serialNumber, setSerialNumber] = useState('');
  const [terminalType, setTerminalType] = useState('pavo');
  const [terminalIntegrationType, setTerminalIntegrationType] =
    useState('cloud');
  const [loading, setLoading] = useState(false);
  const [terminal, setTerminal] = useState<any>();

  const [terminals, setTerminals] = useState<any>([]);
  const [settings, setSetings] = useState<any>([]);
  const [openModal, setOpenModal] = useState(false);
  const [apikey, setApikey] = useState('');
  const [active, setActive] = useState(false);
  const [terminalTypeSetting, setTerminalTypeSetting] = useState('pavo');
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const handleActivateToken = async () => {
    setLoading(true);
    try {
      console.log('Creating terminal with data:', {
        terminal_type: terminalType,
        serial_number: serialNumber,
        name,
      });
      await createTerminalPos({
        terminal_type: terminalType,
        serial_number: serialNumber,
        name,
        terminal_integration_type: terminalIntegrationType,
      });
      enqueueSnackbar('Terminal created successfully', { variant: 'success' });
      fetchTerminalsList(); // Refresh the list after creating a terminal
    } catch (error) {
      console.error('Error in handleActivateToken:', error);
      enqueueSnackbar('Failed to create terminal', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };
  const fetchTerminalsList = async () => {
    try {
      const response = await fetchTerminals();
      console.log('response', response);
      setTerminals(response.data); // Set the terminals state with the data array
    } catch (error) {
      console.error('Error fetching terminals:', error);
    }
  };
  const fetchPaymentSettingList = async () => {
    try {
      const response = await getPaymentSettings();
      console.log('response', response);
      setSetings(response.data);
    } catch (error) {
      console.error('Error fetching terminals:', error);
    }
  };

  const handlePairTerminal = async (terminalId: string) => {
    try {
      await kuikPos.pairTerminal(terminalId);
      enqueueSnackbar('Pair işleminiz başarılı', { variant: 'success' });
      fetchTerminalsList();
    } catch (error) {
      console.error('Error pairing terminal:', error);
      enqueueSnackbar('Failed to pair terminal', { variant: 'error' });
    }
  };

  const handleDeleteTerminal = async (terminalId: string) => {
    try {
      await kuikPos.deleteTerminal(terminalId);
      enqueueSnackbar('Terminal deleted successfully', { variant: 'success' });
      fetchTerminalsList(); // Refresh the list after deleting a terminal
    } catch (error) {
      console.error('Error deleting terminal:', error);
      enqueueSnackbar('Failed to delete terminal', { variant: 'error' });
    }
  };

  const handleDeleteSettings = async (settingsId: string) => {
    try {
      await kuikPos.deleteSettings(settingsId);
      enqueueSnackbar('Settings deleted successfully', { variant: 'success' });
      fetchPaymentSettingList(); // Refresh the list after deleting a terminal
    } catch (error) {
      console.error('Error deleting terminal:', error);
      enqueueSnackbar('Failed to delete settings', { variant: 'error' });
    }
  };

  const handleActivateTokenSettings = async () => {
    setLoading(true);
    try {
      console.log('Creating terminal with data:', {
        terminal_type: terminalType,
        serial_number: serialNumber,
        name,
      });

      await createPaymentGateway({
        payment_gateway_slug: terminalTypeSetting,
        is_active: active,
        credentials: {
          api_key: apikey,
        },
      });
      enqueueSnackbar('Terminal created successfully', { variant: 'success' });
      fetchPaymentSettingList(); // Refresh the list after creating a terminal
    } catch (error) {
      console.error('Error in handleActivateToken:', error);
      enqueueSnackbar('Failed to create terminal', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTerminalsList();
    fetchPaymentSettingList();
  }, []);
  useEffect(() => {
    console.log('Selected terminal:', terminal);
  }, [terminal]);

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper
        elevation={3}
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          marginBottom: '32px',
        }}
      >
        <Box
          sx={{
            width: 50,
            height: 50,
            borderRadius: '50%',
            backgroundColor: '#E0F7FA',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h5" color="primary">
            <img
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
              src={kırmızı}
              alt=""
            />
          </Typography>
        </Box>
        <Typography variant="h6" ml={2}>
          Kuik e-Fatura POS
        </Typography>
      </Paper>

      <Paper elevation={3} sx={{ p: 4, marginBottom: '32px' }}>
        <Typography variant="h6" gutterBottom>
          Yeni Cihaz Ekleyin
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, marginBottom: 2 }}>
          <TextField
            size="small"
            label="Cihaz Adı"
            variant="outlined"
            fullWidth
            value={name}
            onChange={e => setName(e.target.value)}
          />
          <TextField
            size="small"
            label="Seri NO"
            variant="outlined"
            fullWidth
            value={serialNumber}
            onChange={e => setSerialNumber(e.target.value)}
          />
          <Select
            size="small"
            fullWidth
            value={terminalType}
            onChange={e => setTerminalType(e.target.value)}
            sx={{ height: 36.5 }}
          >
            <MenuItem value="pavo">Pavo</MenuItem>
          </Select>
          <Select
            size="small"
            fullWidth
            value={terminalIntegrationType}
            onChange={e => setTerminalIntegrationType(e.target.value)}
            sx={{ height: 36.5 }}
          >
            <MenuItem value="cloud">Cloud</MenuItem>
          </Select>
          <Button
            variant="contained"
            color="success"
            sx={{ minWidth: '100px', height: 36.5 }}
            onClick={handleActivateToken}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'EKLE'}
          </Button>
        </Box>
        <Typography variant="h6" gutterBottom>
          Kayıtlı Cihazlar
        </Typography>
        <Divider sx={{ marginBottom: 2 }} />
        <Box sx={{ display: 'grid', gap: 2 }}>
          {Array.isArray(terminals) &&
            terminals.map(terminal => (
              <Box
                key={terminal.id}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography>
                  {terminal.name} - {terminal.serial_number} -{' '}
                  {terminal.pairing_result && (
                    <>
                      <span style={{ color: '#50cd89' }}>Eşleşti:</span>{' '}
                      {terminal.pairing_result?.cloud?.data.pairingCode}
                    </>
                  )}
                </Typography>
                <div>
                  {terminal.pairing_result && (
                    <Tooltip title="Eşleştirildi" arrow>
                      <IconButton
                        onClick={() => handlePairTerminal(terminal.id)}
                        sx={{ marginRight: 1 }}
                      >
                        <Icon name="LeakAdd" color="success" />
                      </IconButton>
                    </Tooltip>
                  )}
                  {!terminal.pairing_result && (
                    <Tooltip title="Eşleştir" arrow>
                      <Button
                        variant="contained"
                        color="success"
                        size={'small'}
                        sx={{ marginRight: 1 }}
                        onClick={() => handlePairTerminal(terminal.id)}
                      >
                        <Icon name="LeakAdd" />
                      </Button>
                    </Tooltip>
                  )}
                  <Tooltip title="Düzenle" arrow>
                    <Button
                      variant="contained"
                      color="success"
                      size={'small'}
                      sx={{ marginRight: 1 }}
                      onClick={() => {
                        setTerminal(terminal);
                        setOpenModal(true);
                      }}
                    >
                      <Icon name="Edit" />
                    </Button>
                  </Tooltip>
                  <Tooltip title="Kaldır" arrow>
                    <Button
                      variant="contained"
                      color="error"
                      size={'small'}
                      onClick={() => handleDeleteTerminal(terminal.id)}
                    >
                      <Icon name="Delete" />
                    </Button>
                  </Tooltip>
                </div>
              </Box>
            ))}
        </Box>
        <UpdateTerminalModal
          terminal={terminal}
          open={openModal}
          onClose={() => {
            setOpenModal(false);
            fetchTerminalsList();
          }}
        />
      </Paper>
      <Paper elevation={3} sx={{ p: 4, marginBottom: '32px' }}>
        <Typography variant="h6" gutterBottom>
          Cihaz Ayarları
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, marginBottom: 2 }}>
          <TextField
            size="small"
            label="Apı Key"
            variant="outlined"
            fullWidth
            value={apikey}
            onChange={e => setApikey(e.target.value)}
          />
          <Select
            size="small"
            fullWidth
            value={terminalTypeSetting}
            onChange={e => setTerminalTypeSetting(e.target.value)}
            sx={{ height: 36.5 }}
          >
            <MenuItem value="pavo">Pavo</MenuItem>
          </Select>

          <FormControlLabel
            control={
              <Switch
                checked={active}
                onChange={() => setActive(!active)} // Static switch, always checked
                inputProps={{ 'aria-label': 'controlled' }}
              />
            }
            label="Aktif"
          />
          <Button
            variant="contained"
            color="success"
            sx={{ minWidth: '100px', height: 36.5 }}
            onClick={handleActivateTokenSettings}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'EKLE'}
          </Button>
        </Box>
        <Typography variant="h6" gutterBottom>
          Ayarlar
        </Typography>
        <Divider sx={{ marginBottom: 2 }} />
        <Box sx={{ display: 'grid', gap: 2 }}>
          {Array.isArray(settings) &&
            settings.map(s => (
              <Box
                key={s.id}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography>Key: {s.credentials.api_key}</Typography>
                <div>
                  <Tooltip title="Kaldır" arrow>
                    <Button
                      variant="contained"
                      color="error"
                      size={'small'}
                      onClick={() => handleDeleteSettings(s.id)}
                    >
                      <Icon name="Delete" />
                    </Button>
                  </Tooltip>
                </div>
              </Box>
            ))}
        </Box>
        <UpdateTerminalModal
          terminal={terminal}
          open={openModal}
          onClose={() => {
            setOpenModal(false);
            fetchTerminalsList();
          }}
        />
      </Paper>
    </Container>
  );
};

export default KuikPosPage;
